import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import DialogContent from '@material-ui/core/DialogContent'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import IconClose from '../icons/IconClose'
import CheckCircle from '@material-ui/icons/CheckCircle'
import Error from '@material-ui/icons/Error'

const styles = (theme) => ({
  paper: {
    overflow: 'inherit',
    backgroundColor: theme.palette.background.paper,
  },
  root: {
    '& > div': {
      overflow: 'inherit',
    },
  },
  content: {
    minHeight: 120,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '20px 24px',
  },
  closeButton: {
    position: 'absolute',
    top: -20,
    right: -20,
    zIndex: 1000,
    '&, &:hover, &:focus': {
      background: '#229FFF',
      color: '#fff',
      width: 40,
      height: 40,
      marginLeft: 'auto',
    },
    '&:active': {
      background: '#1976d2',
    },
    '@media (max-width: 600px)': {
      width: 44,
      height: 44,
      '&::before': {
        content: '""',
        position: 'absolute',
        top: -4,
        left: -4,
        right: -4,
        bottom: -4,
        backgroundColor: 'transparent',
      },
    },
  },
  iconContainer: {
    marginBottom: 16,
    display: 'flex',
    justifyContent: 'center',
  },
  successIcon: {
    fontSize: 48,
    color: '#4caf50',
  },
  errorIcon: {
    fontSize: 48,
    color: '#f44336',
  },
  description: {
    fontSize: 16,
    color: '#757575',
    lineHeight: 1.5,
    maxWidth: 300,
  },
  title: {
    padding: '16px 24px 0',
    paddingRight: 56,
    textAlign: 'center',
    position: 'relative',
    '& h2': {
      fontSize: '1.25rem',
      fontWeight: 500,
      color: '#003884',
    },
  },
})

class PDFStatusDialog extends React.Component {
  handleClose = (event) => {
    if (event) {
      event.stopPropagation()
    }
    this.props.onClose()
  }

  render() {
    const { classes, open, type = 'error', title, description, ...other } = this.props

    const isSuccess = type === 'success'
    const isError = type === 'error'

    return (
      <Dialog
        maxWidth="xs"
        fullWidth
        aria-labelledby="pdf-status-dialog-title"
        className={classes.root}
        open={open}
        onClose={this.handleClose}
        disableBackdropClick={false}
        disableEscapeKeyDown={false}
        {...other}
      >
        <DialogTitle id="pdf-status-dialog-title" className={classes.title}>
          <IconButton
            className={classes.closeButton}
            onClick={this.handleClose}
            aria-label="Fechar"
            onTouchStart={(e) => e.stopPropagation()}
            onTouchEnd={this.handleClose}
          >
            <IconClose style={{ fontSize: 20 }} viewBox={'0 0 20 20'} />
          </IconButton>
          {title}
        </DialogTitle>

        <DialogContent className={classes.content}>
          <div className={classes.iconContainer}>
            {isSuccess && <CheckCircle className={classes.successIcon} />}
            {isError && <Error className={classes.errorIcon} />}
          </div>

          <Typography className={classes.description}>{description}</Typography>
        </DialogContent>
      </Dialog>
    )
  }
}

export default withStyles(styles)(PDFStatusDialog)
